import { ApolloLink } from "./ApolloLink.js";
export var concat = ApolloLink.concat;
//# sourceMappingURL=concat.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@apollo/client/link/core/concat.js
// module id = ./node_modules/@apollo/client/link/core/concat.js
// module chunks = 54 55